export function extractPkFromLocation(locationObj = location) {
  const params = new URLSearchParams(locationObj.search);
  const result = params.get('pk');
  return result ? result : '';
}
